import { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

import {
	MplStepProgress,
	MplTopSectionHeader,
	StyledDTicketPageLayoutContainer,
	StyledDTicketPageLayoutContent,
	StyledSafeAreaHeader,
} from '@mopla/ui';

export interface ISubscribeDTicketLayoutProps {
	title: string;
	subtitle: string;
	currentStep: number;
	totalSteps: number;
	onBack: () => void;
	children: ReactNode;
	dataTestId?: string;
}

export const SubscribeDTicketLayout = ({
	title,
	subtitle,
	currentStep,
	totalSteps,
	onBack,
	children,
	dataTestId,
}: ISubscribeDTicketLayoutProps) => {
	return (
		<StyledDTicketPageLayoutContainer data-testid={dataTestId}>
			<Box
				sx={{
					position: 'sticky',
					top: 0,
					zIndex: 1,
					backgroundColor: 'neutral.main',
				}}
			>
				<StyledSafeAreaHeader>
					<MplTopSectionHeader
						title={title}
						subtitle={subtitle}
						onBack={onBack}
						dataTestId={dataTestId}
					/>
				</StyledSafeAreaHeader>
				<Stack
					sx={{
						mx: -2,
						mb: 1,
						'& .MuiLinearProgress-root': { height: 3 },
					}}
				>
					<MplStepProgress value={currentStep} maxSteps={totalSteps} />
				</Stack>
			</Box>

			<StyledDTicketPageLayoutContent
				scrollable
				sx={{ pb: 'calc(159px + max(24px, env(safe-area-inset-bottom)))' }}
			>
				{children}
			</StyledDTicketPageLayoutContent>
		</StyledDTicketPageLayoutContainer>
	);
};
